





























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalAplicarModeloCirurgia extends Vue {
  loadAplicarModeloCirurgia: boolean = false

  get loadingAplicarModeloCirurgia() { return this.loadAplicarModeloCirurgia }
  set loadingAplicarModeloCirurgia(value: boolean) { this.loadAplicarModeloCirurgia = value }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get showModalAplicarModeloCirurgia() {
    return this.getSolicitacaoPendenciaStore.showModalAplicarModeloCirurgia
  }

  set showModalAplicarModeloCirurgia(value: boolean) {
    this.getSolicitacaoPendenciaStore.setShowModalAplicarModeloCirurgia(value)
  }

  get modeloCirurgiaId() {
    return this.getSolicitacaoPendenciaStore.modeloCirurgiaId
  }

  set modeloCirurgiaId(value: string) {
    this.getSolicitacaoPendenciaStore.setModeloCirurgiaId(value)
  }

  get modelosCirurgia() {
    return this.getSolicitacaoPendenciaStore.modelosCirurgia
  }

  async aplicarCirurgiaModelo() {
    this.loadingAplicarModeloCirurgia = true
    const request = await this.getSolicitacaoPendenciaStore.aplicarCirurgiaModelo()
    if (request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ação realizada com sucesso.', icon: 'done', color: '#2E7D32' })
      this.showModalAplicarModeloCirurgia = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828' })
    }
    this.loadingAplicarModeloCirurgia = false
  }

  @Watch('showModalAplicarModeloCirurgia')
  onChangeShowModalAplicarModeloCirurgia(value: boolean) {
    if (!value) {
      this.getSolicitacaoPendenciaStore.setModeloCirurgiaId('')
      this.getSolicitacaoPendenciaStore.clearModelosCirurgia()
    }
  }
}
